import type { ListingProduct } from '~/models/ListingProduct.api.model';
import FetchFactory from '../factory';

const CONTROLLER_PATH = '/api-electra/Plan/';

export type GetAllPlansResponse = {
  Data?: ListingProduct[];
};

interface VerifyFamilyPlanOwnerRequest {
  SocialSecurityNumber: string;
}

class PlanModule extends FetchFactory<any> {
  async getAllPlans(): Promise<GetAllPlansResponse> {
    const url = `${CONTROLLER_PATH}GetAllPlans`;

    const response = await this.get(url);
    return response;
  }

  async verifyFamilyPlanOwnerSsn(ssn: string): Promise<any> {
    const url = `${CONTROLLER_PATH}VerifyFamilyPlanOwner`;
    const requestPayload: VerifyFamilyPlanOwnerRequest = {
      SocialSecurityNumber: ssn,
    };

    const response = await this.post(url, requestPayload);
    return response;
  }
}

export default PlanModule;
